export const EMAIL_HISTORY_STORE = 'EMAIL_HISTORY_STORE';
export const EMAIL_HISTORY_UPDATE = 'EMAIL_HISTORY_UPDATE';
export const EMAIL_HISTORY_DESTROY = 'EMAIL_HISTORY_DESTROY';
